import UnassignedStopRow from './component';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const stopFields = ['shipper_order_id', 'shipper_order_ids', 'isCancelled', 'store'];
const journeyFields = ['shipper_orders_skin', 'status'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { shipper_orders_skin, status } = props.selectors.getJourneyFields(
      state,
      props.journeyId,
      journeyFields
    );

    const { store, shipper_order_id, isCancelled, shipper_order_ids } =
      props.selectors.getJourneyStopFields(state, props.journeyId, props.stopId, stopFields);

    return {
      skin: shipper_orders_skin[shipper_order_id],
      store,
      isAggregated: (shipper_order_ids || []).length > 1,
      isPartiallyCancelled: isCancelled && status !== 'CANCELLED',
    };
  }),
  withProps(({ numberOfStops }) => ({
    showLoadInfo: numberOfStops > 2,
  }))
);

export default enhance(UnassignedStopRow);
